import React from 'react';
import HeaderPreview from '../../../GeneratePdf/HeaderPreview';
import SnapshotImgPreview360 from './SnapshotImgPreview360';
import FooterPreview from '../../../GeneratePdf/FooterPreview';

export default function SnapshotSecond360({ apiData, reportType, pageNumber }) {


  const styles = {
    pageWrapper: { backgroundColor: "#FFFFFF" },
    mainTitle: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "14px", lineHeight: "18px", color: "#00577D", margin: 0, padding: "16px 0px" },
    introText: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "10px", lineHeight: "14px", color: "#000000", margin: 0, paddingBottom: "16px" },
    subText: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 400, fontSize: "10px", lineHeight: "14px", color: "#000000", margin: 0, paddingBottom: "16px" },
    rememberTitle: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "10px", lineHeight: "14px", color: "#000000", margin: 0, paddingBottom: "10px" },
    rememberItem: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 400, fontSize: "10px", lineHeight: "14px", color: "#000000", margin: 0, paddingBottom: "6px" },
    resultsTitle: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "14px", lineHeight: "18px", color: "#00577D", margin: 0, padding: "16px 0px" },
    cardsContainer: { display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", padding: "0px", gap: "24px" },
    leftColumn: { display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "0px", gap: "24px", width: "208px", height: "188px" },
    rightColumn: { display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "0px", gap: "24px", width: "208px", height: "187.94px" },
    cardWrapper: { position: "relative", width: "208px", height: "82px" },
    card: { boxSizing: "border-box", position: "absolute", width: "208px", height: "73px", left: "0px", top: "9px", background: "#FFFFFF", border: "2px solid #00577D", borderRadius: "10px" },
    cardLabel: { position: "relative", width: "12ch", margin: "0px auto", left: "0px", top: "0px", background: "#FFFFFF", fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "11px", lineHeight: "15px", display: "flex", alignItems: "center", textAlign: "center", color: "#000000", justifyContent: "center" },
    cardContent: { display: "flex", flexDirection: "row", alignItems: "center", padding: "0px", gap: "16px", position: "absolute", height: "32px", left: "16px", top: "30px" },
    iconWrapper: { width: "32px", height: "32px" },
    icon: { width: "32px", height: "32px", objectFit: "contain" },
    content: { display: "flex",  flexDirection: "row", alignItems: "start", justifyContent: "start", gap: "1px" },
    cardText: { fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 400, fontSize: "11px", lineHeight: "15px", textTransform: "capitalise", color: "#000000", whiteSpace: "nowrap" },
  };

  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview apiData={apiData} />
      <h2 style={styles.mainTitle}>SNAPSHOT RESULTS</h2>

      <p style={styles.introText}>
        This assessment offers a structured look at your life and leadership, grounded in validated testing. The results are designed to spark self-awareness and guide your growth. They provide valuable information, but they do not capture the full depth of who you are.
      </p>

      <p style={styles.subText}>
        Think of this Snapshot as a starting point for discovery. Self-assessment results reflect your own perspective, while 360° feedback brings in the views of others. Both are most helpful when explored with a trusted coach or consultant who can help you apply what you see.
      </p>

      <p style={styles.rememberTitle}>THREE THINGS TO REMEMBER:</p>

      <p style={styles.rememberItem}>
        <strong>1. This is a starting point.</strong> Your results open the door to discovery and are not a final verdict.
      </p>

      <p style={styles.rememberItem}>
        <strong>2. Growth improves with guidance.</strong> Working with a coach or guide helps you turn insight into action.
      </p>

      <div style={styles.content}>
       <strong>3.</strong>{" "}<p style={styles.rememberItem}>
          <strong>You are more than your data.</strong> These findings highlight patterns, but they do not define your worth or potential.
        </p>
      </div>

      <h2 style={styles.resultsTitle}>YOUR SNAPSHOT RESULTS</h2>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <SnapshotImgPreview360 apiData={apiData} />
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
}
